import { PanelPlugin } from '@grafana/data';
import { PluginList } from './PluginList';

export const plugin = new PanelPlugin(PluginList);
